export * from './interface/furnhome-communication';
export * from './implementation/browser-furnhome-communication';

/**
 * Der Token, unter dem der Client seine Communication registriert und der StateManager sie bekommt.
 * Gleiche Form wie `FurnportCommunicationToken` und `UserManagementCommunicationToken`.
 */
export const FurnhomeCommunicationToken = 'FurnhomeCommunication';
